'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ByArtistName = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ByArtistName, _PureComponent);

  function ByArtistName() {
    (0, _classCallCheck3.default)(this, ByArtistName);
    return (0, _possibleConstructorReturn3.default)(this, (ByArtistName.__proto__ || (0, _getPrototypeOf2.default)(ByArtistName)).apply(this, arguments));
  }

  (0, _createClass3.default)(ByArtistName, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          artistName = _props.artistName;
      var t = this.context.t;


      if (!artistName) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { className: className },
        t('by {{artistName}}', { artistName: artistName })
      );
    }
  }]);
  return ByArtistName;
}(_react.PureComponent), _class.propTypes = {
  artistName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  className: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = ByArtistName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ByArtistName/ByArtistName.js
// module id = 817
// module chunks = 1